import { Component, EventEmitter, Output } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-profile-header',
  imports: [TranslateModule],
  templateUrl: './profile-header.html',
  styleUrl: './profile-header.scss',
})
export class ProfileHeader {
  @Output() readonly createRequested = new EventEmitter<void>();

  requestCreate(): void {
    this.createRequested.emit();
  }
}
